<template>
  <v-row no-gutters>
    <v-col>
      <v-textarea
          :value="text"
          hide-details
          placeholder="데이터 입력"
          solo
          @change="analyzeData"
      ></v-textarea>
    </v-col>
    <v-col>
      <v-textarea
          hide-details
          v-model="errorText"
          placeholder="Errors"
          readonly
          solo
      ></v-textarea>
    </v-col>
  </v-row>
</template>

<script>

  export default {
    name: "TsRecordMaker",
    props: {
      text: String,
      players: {
        type: Array,
        default: () => ([])
      },
      records: Array
    },
    data () {
      return {
        playerNames: [],
        errors: [],
        results: [],
        dateMatch: [
          /\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}:\d{1,2}/,
          /(\d{4})년\s?(\d{1,2})월\s?(\d{1,2})일\s?(오후|오전)\s?(\d{1,2}):(\d{1,2})/
        ],
        dansikMatch: null,
        boksikMatch: null,
        mans: null,
      }
    },
    computed: {
      errorText(){
        return this.errors.join('\n')
      }
    },
    watch: {
      text(val){
        this.analyzeData(val)
      }
    },
    mounted() {
      this.initParseResource(this.players)
    },
    methods: {
      makeFormattedData({players,result,date}){
        const boksik = players.length === 4 || players.size === 4
        date = this.$day(date || undefined).dateTimeFormat()

        if (result[1] > result[0]) {
          result.push(...result.splice(0, 1))
          players.push(...players.splice(0, boksik ? 2 : 1))
        }
        return {
          date,
          boksik,
          players,
          winners: (boksik ? [players[0], players[1]] : [players[0]]).sort(),
          losers: (boksik ? [players[2], players[3]] : [players[1]]).sort(),
          result: result.map(item => parseInt(item))
        }
      },
      validatePlayerData(players){
        const error = []
        const tempSet = new Set();

        if(!players) error.push(' - playerData 없음')
        else{
          for (const j in players) {
            if (this.playerNames.includes(players[j]))
              tempSet.add(players[j])
          }
          if (tempSet.size !== 2 && tempSet.size !== 4) {
            error.push(" - 참가자 수가 2,4명이 아님")
          }
        }

        return {data: tempSet, error}
      },
      validateResultData(result){
        const error = []
        if (result == null || result.length !== 2) {
          error.push(" - 숫자가 2개가 아님")
        }else if (result[0] === result[1]) {
          error.push(" - 무승부")
        }
        return {error}
      },
      getDateFormat(txt){
        let date = this.dateMatch[1].exec(txt)
        date && (date = `${date[1]}-${date[2]}-${date[3]} ${date[5] - -(date[4] === '오후' ? 12 : 0)}:${date[6]}:00`)
        if (!date) {
          date = this.dateMatch[0].exec(txt)
          date && (date = date[0])
        }
        return date
      },
      fromJSON(json){
        const arr = Array.isArray(json) ? json : [json]
        return arr.filter(item => {
          const dateData = this.getDateFormat(item.date)
          item.players = item.players || [...item.winners, ...item.losers]
          const {error:errorP} = this.validatePlayerData(item.players)
          const {error:errorR} = this.validateResultData(item.result)
          if( !(dateData && !errorP.length && !errorR.length) ) {
            const errors = [...errorP,...errorR]
            !dateData && errors.push("-noDate")
            this.errors.push(...errors.map((msg)=>JSON.stringify(item) + msg))
            return false
          }
          return true
        }).map(item => this.makeFormattedData(item))
      },
      fromText (txtFull) {
        const splited = txtFull.split('\n');
        const __res = [];

        let prevDate = null

        for (let i in splited) {
          const txt = splited[i].trim();
          if (txt.length === 0) continue;
          let matched = txt.match(this.dansikMatch) || txt.match(this.boksikMatch);
          if (matched == null) {
            this.errors.push(txt + " - 게임데이터 찾을 수 없음");
            continue;
          }
          matched = matched[0];

          const result = matched.match(/\d+/g);
          const players = matched.match(this.mans);
          let date = this.getDateFormat(txt)
          !date && (date = prevDate)

          const {error:error1} = this.validateResultData(result)
          const {error:error2} = this.validatePlayerData(players)

          const errors = [...error1,...error2]
          if (errors.length){
            this.errors.push(...errors.map(err => txt+err))
            continue
          }
          __res.push(this.makeFormattedData({result,players,date}))
          prevDate = date
        }

        return __res
      },
      analyzeData(txt){
        if(!this.players.length) return this.$alert('Player가 없으면 데이터 입력 불가능합니다.')
        else this.initParseResource(this.players)
        this.errors = []
        this.results = []
        try{
          this.results = this.fromJSON(JSON.parse(txt))
        }catch(e){
          this.results = this.fromText(txt)
        }
        this.$emit('parse', this.results, this.errors)
        this.$emit('update:records', this.results)
      },
      initParseResource (players) {
        this.playerNames = players.map(({name}) => name)

        const nameJoined = this.playerNames.join('|')
        this.dansikMatch = new RegExp(`(${nameJoined})\\s*\\d+\\s*(${nameJoined})\\s*\\d+`)
        this.boksikMatch = new RegExp(`(${nameJoined})\\s*(${nameJoined})\\s*\\d+\\s*(${nameJoined})\\s*(${nameJoined})\\s*\\d+`)
        this.mans = new RegExp(`(${nameJoined})`, 'g');
      },
    }
  }
</script>
